'use strict'

module.exports = class Dir {
}



//////////////////
// WEBPACK FOOTER
// ./~/ipfs-unixfs-engine/src/importer/dir.js
// module id = 135
// module chunks = 0